<template>
  <template v-if="store.isPresential && store.loaded">
    <!-- Sem localização (amber) -->
    <div
      v-if="store.needsLocation && !dismissed.location"
      class="bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm"
    >
      <div class="flex items-center gap-2 flex-wrap">
        <span class="mdi mdi-map-marker-alert text-base flex-shrink-0"></span>
        <span>Seu endereço de atuação não foi encontrado. Sem ele, você não aparece nas buscas.</span>
        <router-link to="/perfil" class="font-semibold underline hover:no-underline">Completar agora</router-link>
      </div>
      <button @click="dismiss('location')" class="text-amber-700 hover:text-amber-950 flex-shrink-0" title="Fechar">✕</button>
    </div>

    <!-- Sem serviços (vermelho) -->
    <div
      v-if="store.needsServices && !dismissed.services"
      class="bg-red-50 border-b border-red-300 text-red-800 px-4 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm"
    >
      <div class="flex items-center gap-2 flex-wrap">
        <span class="mdi mdi-briefcase-alert text-base flex-shrink-0"></span>
        <span>Você não tem nenhum serviço ativo cadastrado. Clientes não conseguem te contratar!</span>
        <router-link to="/meus-servicos" class="font-semibold underline hover:no-underline">Cadastrar serviço</router-link>
      </div>
      <button @click="dismiss('services')" class="text-red-600 hover:text-red-900 flex-shrink-0" title="Fechar">✕</button>
    </div>

    <!-- Sem disponibilidade (azul) -->
    <div
      v-if="store.needsSchedule && !dismissed.schedule"
      class="bg-blue-50 border-b border-blue-200 text-blue-800 px-4 py-2 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-sm"
    >
      <div class="flex items-center gap-2 flex-wrap">
        <span class="mdi mdi-calendar-alert text-base flex-shrink-0"></span>
        <span>Sua disponibilidade semanal não está configurada. Clientes não conseguem agendar horários.</span>
        <router-link to="/minha-agenda" class="font-semibold underline hover:no-underline">Configurar agenda</router-link>
      </div>
      <button @click="dismiss('schedule')" class="text-blue-600 hover:text-blue-900 flex-shrink-0" title="Fechar">✕</button>
    </div>
  </template>
</template>

<script setup>
import { reactive } from 'vue'
import { useProviderOnboardingStore } from '@/store/providerOnboardingStore'

const store = useProviderOnboardingStore()

const dismissed = reactive({
  location: sessionStorage.getItem('banner_dismissed_location') === '1',
  services: sessionStorage.getItem('banner_dismissed_services') === '1',
  schedule: sessionStorage.getItem('banner_dismissed_schedule') === '1',
})

function dismiss(type) {
  dismissed[type] = true
  sessionStorage.setItem(`banner_dismissed_${type}`, '1')
}
</script>
